import {saveQuestionDataInCache, getAnswersDataFromCache} from 'helpers/cache/cacheManager'
import removePrefix from './remove_prefix'

const answer_prefix = 'Answer:'

function saveQuizQuestionData(submitData, session) {
	saveQuestionDataInCache(
		submitData.answers,
		session.presentation_uid,
		session.session_uid,
		session.join_token,
		session.pincode
	)
}

async function getQuizAnswersData(questionData, session) {
	const newAnswers = questionData.questions.reduce(function(previousAnswers, question) {
		const newAnswers = question.options.map(option => option.key)
		return [...previousAnswers, ...newAnswers]
	}, [])

	const answersFromCache = await getAnswersDataFromCache(
		newAnswers,
		session.presentation_uid,
		session.session_uid,
		session.join_token,
		session.pincode
	)

	return answersFromCache
		.filter(answer => answer.value !== '0')
		.map(answer => removePrefix(answer_prefix, answer.key))
}

export {
	saveQuizQuestionData,
	getQuizAnswersData,
}
